import { RecruitGroupCreatorListDto, ScreeningListResponseDto } from '@/app/common/general-types/social-screening.dto';
import { Injectable, computed, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ManageBriefTabsMonitorService {
  focussedMonitoringBrief = signal<any | undefined>(undefined);
  selectedComplianceDocs = signal<any[] | undefined>(undefined);

  creatorList = computed<ScreeningListResponseDto | RecruitGroupCreatorListDto | undefined>(
    () => this.focussedMonitoringBrief()?.creatorList as ScreeningListResponseDto | RecruitGroupCreatorListDto | undefined,
  );
}
